import defaultsDeep from 'lodash/defaultsDeep';
export class Schedule {
    #model;
    static DEFAULT_MODEL = {
        enabled: true,
        version: 3,
        data: { ics: '' }
    };
    constructor(model) {
        if (!(model instanceof Schedule)) {
            model = defaultsDeep({}, model, Schedule.DEFAULT_MODEL);
        }
        this.#model = model;
    }
    get id() {
        return this.#model.id;
    }
    get org() {
        return this.#model.org;
    }
    get name() {
        return this.#model.name;
    }
    get nameWithStatus() {
        return `${this.name}${this.enabled ? '' : ' (disabled)'}`;
    }
    get enabled() {
        return this.#model.enabled ?? true;
    }
    get timezone() {
        return this.#model.timezone;
    }
    get version() {
        return this.#model.version || Schedule.DEFAULT_MODEL.version;
    }
    get data() {
        return this.#model.data || { ics: '' };
    }
    get isLegacy() {
        return this.version < 3;
    }
    isNew() {
        return !this.id;
    }
    getModel() {
        return this.#model instanceof Schedule ? this.#model.getModel() : this.#model;
    }
    updateModel(model) {
        this.#model = model;
    }
    toJSON() {
        return this.getModel();
    }
}
